import { render } from "./CardBlock.vue?vue&type=template&id=be99aee2"
import script from "./CardBlock.vue?vue&type=script&lang=js"
export * from "./CardBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__